import makeReCatpchaBlocker from "./reCatpcha.js";
import makeDummyBlocker from "./dummy.js";

function getRecatpchaSiteKey() {
    return window.REBELMOUSE_BOOTSTRAP_DATA.engine.recaptchaSiteKey;
}

export default function getBlocker() {
    const recatpchaKey = getRecatpchaSiteKey();

    if (recatpchaKey) {
        return makeReCatpchaBlocker(recatpchaKey);
    }

    return makeDummyBlocker();
}
